export default __webpack_public_path__ + "static/media/transaction-done-modal-logo.ea46ee71.svg";